// autogenerated
import {AthenaeumConstants, ServiceProvider} from "@reapptor-apps/reapptor-toolkit";
import {ETagRequest} from "@reapptor-apps/reapptor-react-common";

export default class ListServiceProvidersRequest extends ETagRequest {

    public countryCode: string | null = null;

    public whiteLabelingOnly: boolean = false;

    public shuttleOnly: boolean = false;

    public readonly isListServiceProvidersRequest: true = true;

    public static is(from?: object | null): boolean {
        // noinspection PointlessBooleanExpressionJS
        return (from != null) && ((from instanceof ListServiceProvidersRequest) || ((from as any).isListServiceProvidersRequest === true));
    }

    public static as(from?: object | null): ListServiceProvidersRequest | null {
        return (ListServiceProvidersRequest.is(from)) ? from as ListServiceProvidersRequest : null;
    }

    // #region Placeholder

    // Put your code here (function, properties, ect...)

    // #endregion
}

ServiceProvider.addType(ListServiceProvidersRequest, "ListServiceProvidersRequest");